var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStatusReportBig = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 120,
  fill: "none",
  viewBox: "0 0 120 120"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 70,
  height: 80,
  x: 25,
  y: 20,
  stroke: "currentColor",
  strokeWidth: 3,
  rx: 4
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 50,
  height: 8,
  x: 35,
  y: 35,
  fill: "currentColor",
  opacity: 0.3,
  rx: 4
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 6,
  x: 35,
  y: 50,
  fill: "currentColor",
  opacity: 0.3,
  rx: 3
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 45,
  height: 6,
  x: 35,
  y: 62,
  fill: "currentColor",
  opacity: 0.3,
  rx: 3
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 35,
  height: 6,
  x: 35,
  y: 74,
  fill: "currentColor",
  opacity: 0.3,
  rx: 3
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 6,
  x: 35,
  y: 86,
  fill: "currentColor",
  opacity: 0.3,
  rx: 3
})));
export default SvgStatusReportBig;